import { render, staticRenderFns } from "./KPIStatusBadge.vue?vue&type=template&id=d21781ea&scoped=true"
import script from "./KPIStatusBadge.vue?vue&type=script&setup=true&lang=js"
export * from "./KPIStatusBadge.vue?vue&type=script&setup=true&lang=js"
import style0 from "./KPIStatusBadge.vue?vue&type=style&index=0&id=d21781ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d21781ea",
  null
  
)

export default component.exports